import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

import { InteractivePlanComponent } from './interactive-plan.component';
import { IndicatorDetailDialogComponent } from './indicator-detail-dialog/indicator-detail-dialog.component';

@NgModule({
  declarations: [
    InteractivePlanComponent,
    IndicatorDetailDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatDialogModule
  ],
  exports: [
    InteractivePlanComponent
  ]
})
export class InteractivePlanModule { }



